import { createContent } from '@altify/utils';

export const submitOrderContent = createContent({
  en: {
    tradeComplete: 'Trade Complete',
    executingTrade: 'Executing Trade',
    thisMayTakeAMoment: 'This may take a moment',
    exploreProducts: 'Explore Products',
    received: "You've Received",
    receiving: "You're Receiving",
    buying: "You're Buying",
    createRecurringBuy: 'Create a Recurring Buy',
    retry: 'Try Again',
    cancelTrade: 'Cancel Trade',
    error: 'Your trade could not execute',
  },
  de: {
    tradeComplete: 'Trade abgeschlossen',
    executingTrade: 'Trade wird ausgeführt',
    thisMayTakeAMoment: 'Dies kann einen Moment dauern',
    exploreProducts: 'Produkte entdecken',
    received: 'Du hast erhalten',
    receiving: 'Du erhältst',
    buying: 'Du kaufst',
    createRecurringBuy: 'Erstelle einen wiederkehrenden Kauf',
    retry: 'Nochmal versuchen',
    cancelTrade: 'Trade abbrechen',
    error: 'Dein Trade ist fehlgeschlagen, bitte versuche es erneut',
  },
});
